import React from "react";

const WorkDiary = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M10.926 2h19.073v8.377h-.385c-1.847 0-3.695-.014-5.541.005-3.12.033-5.452 2.988-4.802 6.063.489 2.313 2.44 3.964 4.781 4 1.857.027 3.715.007 5.573.008h.348v8.339H10.9V2.37c0-.123.016-.248.026-.371ZM9.07 2c-.01.144-.026.29-.026.433l-.001 25.925v.445c-1.027.048-2.046-.135-3.027.437v-.454c0-8.007.017-16.014-.016-24.02C5.993 3.27 6.647 2.306 7.954 2H9.07ZM7.334 34c-.55-.186-.996-.492-1.214-1.063-.395-1.03.324-2.169 1.419-2.244.102-.008.206-.006.31-.006H30V34H7.334Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M29.984 12.263v6.289c-.087.009-.165.025-.244.025-1.847 0-3.694.013-5.54-.004-1.834-.016-3.213-1.435-3.179-3.232.03-1.596 1.26-2.995 2.866-3.058 2.018-.08 4.042-.02 6.097-.02Zm-6.116 2.14v1.844h1.815v-1.844h-1.815Z"
            fill={fill}
        />
    </svg>
);

export default WorkDiary;